import { RESOURCES } from "@/constants/resource-const"
import {
  Monitor,
  LayoutDashboard,
  Gauge,
  ChartColumnIncreasing,
  Home,
  ShieldAlert
} from "lucide-react"

export const LOGO_SRC = "/images/toicos-logo-a.png"

export const navBundle = {
  title: {
    ko: "미터링케어 서비스\n(MeteringCare)",
    en: "Metering Care\nService",
    es: "Servicio Metering Care"
  },
  navs: [
    {
      type: "item",
      id: "overview",
      label: { ko: "개요", en: "Overview", es: "Resumen" },
      icon: LayoutDashboard
    },
    {
      type: "item",
      id: "monitoring",
      label: { ko: "모니터링", en: "Monitoring", es: "monitoreo" },
      icon: Monitor
    },
    {
      type: "group",
      id: "stats",
      label: { ko: "통계", en: "stats", es: "Estadisticas" },
      icon: ChartColumnIncreasing,
      children: [...RESOURCES]
    },
    {
      type: "group",
      id: "analysis",
      label: { ko: "분석", en: "Analysis", es: "Analisis" },
      icon: Gauge,
      children: [
        {
          id: "leak",
          label: { ko: "옥내누수", en: "Indoor Water Leak", es: "Fuga interior de agua" },
          icon: ShieldAlert,
          colors: {
            text: "text-rose-500",
            groupHoverText: "group-hover:text-rose-500"
          }
        }
        // {
        //   id: "anomaly",
        //   label: { ko: "계량기 이상", en: "Meter Anomaly", es: "Anomalia del medidor" },
        //   icon: Wrench,
        //   colors: {
        //     text: "text-amber-500",
        //     groupHoverText: "group-hover:text-amber-500"
        //   }
        // },
        // {
        //   id: "vacant",
        //   label: { ko: "빈집 세대", en: "Vacant Units", es: "Unidades vacias" },
        //   icon: Home,
        //   colors: {
        //     text: "text-sky-500",
        //     groupHoverText: "group-hover:text-sky-500"
        //   }
        // }
      ]
    },
    {
      type: "group",
      id: "units",
      label: { ko: "세대조회", en: "Unit Search", es: "Consulta por unidad" },
      icon: Home,
      children: [...RESOURCES]
    }
  ]
}
